import axios from 'axios';
/* eslint-disable import/no-cycle */
import Storage from '@/storage';
/* eslint-enable import/no-cycle */

export default class Http {
    static get(path, config = {}) {
        return Http.request({
            url: `/api${path}`,
            method: 'get',
            ...config,
        });
    }

    static post(path, data, config = {}) {
        return Http.request({
            url: `/api${path}`,
            method: 'post',
            data,
            ...config,
        });
    }

    static put(path, data, config = {}) {
        return Http.request({
            url: `/api${path}`,
            method: 'put',
            data,
            ...config,
        });
    }

    static delete(path, config = {}) {
        return Http.request({
            url: `/api${path}`,
            method: 'delete',
            ...config,
        });
    }

    static request(config) {
        const token = Storage.getToken();
        const c = {
            ...config,
            headers: {
                ...config.headers,
                Authorization: token.authorization,
            },
        };
        return new Promise((resolve, reject) => {
            axios
                .request(c)
                .then((response) => {
                    Storage.setToken({
                        authorization: response.headers['access-token'],
                        lifetime: response.headers['token-lifetime'],
                    });
                    resolve(response);
                }).catch((error) => {
                    if (error.response
                        && error.response.headers
                        && error.response.headers['access-token']
                        && error.response.headers['token-lifetime']) {
                        Storage.setToken({
                            authorization: error.response.headers['access-token'],
                            lifetime: error.response.headers['token-lifetime'],
                        });
                    } else {
                        Storage.clearToken();
                    }
                    reject(error.response);
                });
        });
    }

    static getWithoutToken(path, config = {}) {
        return Http.requestWithoutToken({
            url: `/api${path}`,
            method: 'get',
            ...config,
        });
    }

    static postWithoutToken(path, data, config = {}) {
        return Http.requestWithoutToken({
            url: `/api${path}`,
            method: 'post',
            data,
            ...config,
        });
    }

    static putWithoutToken(path, data, config = {}) {
        return Http.requestWithoutToken({
            url: `/api${path}`,
            method: 'put',
            data,
            ...config,
        });
    }

    static deleteWithoutToken(path, config = {}) {
        return Http.requestWithoutToken({
            url: `/api${path}`,
            method: 'delete',
            ...config,
        });
    }

    static requestWithoutToken(config) {
        return new Promise((resolve, reject) => {
            axios
                .request(config)
                .then(response => resolve(response))
                .catch(error => reject(error.response));
        });
    }
}
